<script>
import ListingModel from "@/views/Request/Claim/Components/ListingModel.vue";

export default {
    name: "Claims",
    components: {ListingModel}
}
</script>

<template>
    <listing-model type="CLAIM"/>
</template>

